/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdvertCountResult,
  ApplicationAddRequest,
  ApplicationCreateRequest,
  ApplicationGroup,
  ApplicationVersion,
  EscoLanguage,
  EscoOccupationSimple,
  JobDescriptionToOccupationsRequest,
  JobMatchProfile,
  JobMatchSearchFilters,
  JobMatchSearchResult,
  JobResultItem,
  OccupationByTextRequest,
  OccupationSearchResultDto,
  OccupationUpdateRequest,
} from '../models/index';
import {
    AdvertCountResultFromJSON,
    AdvertCountResultToJSON,
    ApplicationAddRequestFromJSON,
    ApplicationAddRequestToJSON,
    ApplicationCreateRequestFromJSON,
    ApplicationCreateRequestToJSON,
    ApplicationGroupFromJSON,
    ApplicationGroupToJSON,
    ApplicationVersionFromJSON,
    ApplicationVersionToJSON,
    EscoLanguageFromJSON,
    EscoLanguageToJSON,
    EscoOccupationSimpleFromJSON,
    EscoOccupationSimpleToJSON,
    JobDescriptionToOccupationsRequestFromJSON,
    JobDescriptionToOccupationsRequestToJSON,
    JobMatchProfileFromJSON,
    JobMatchProfileToJSON,
    JobMatchSearchFiltersFromJSON,
    JobMatchSearchFiltersToJSON,
    JobMatchSearchResultFromJSON,
    JobMatchSearchResultToJSON,
    JobResultItemFromJSON,
    JobResultItemToJSON,
    OccupationByTextRequestFromJSON,
    OccupationByTextRequestToJSON,
    OccupationSearchResultDtoFromJSON,
    OccupationSearchResultDtoToJSON,
    OccupationUpdateRequestFromJSON,
    OccupationUpdateRequestToJSON,
} from '../models/index';

export interface AddApplicationVersionRequest {
    applicationAddRequest?: ApplicationAddRequest;
}

export interface AddJobMatchProfileOccupationsRequest {
    occupationUpdateRequest?: OccupationUpdateRequest;
}

export interface CreateApplicationRequest {
    applicationCreateRequest?: ApplicationCreateRequest;
}

export interface CreateSavedAdvertRequest {
    body?: number;
}

export interface DeleteApplicationRequest {
    applicationGroupId?: number;
}

export interface DeleteSavedAdvertRequest {
    body?: number;
}

export interface GetAdvertRequest {
    jobId?: number;
}

export interface GetApplicationRequest {
    applicationGroupId?: number;
}

export interface GetApplicationTextRequest {
    applicationGroupId?: number;
    versionId?: number;
    returnAsWordDocument?: boolean;
}

export interface GetJobMatchProfileRequest {
    language?: EscoLanguage;
}

export interface GetMatchesForProfileRequest {
    jobMatchSearchFilters?: JobMatchSearchFilters;
}

export interface GetOccupationsByStringRequest {
    occupationByTextRequest?: OccupationByTextRequest;
}

export interface JobDescriptionToOccupationsOperationRequest {
    jobDescriptionToOccupationsRequest?: JobDescriptionToOccupationsRequest;
}

export interface RemoveJobMatchProfileOccupationsRequest {
    occupationUpdateRequest?: OccupationUpdateRequest;
}

export interface SetApplicationVersionRequest {
    applicationGroupId?: number;
    versionId?: number;
}

export interface UnsubscibeEmailRequest {
    candidateId?: string;
}

export interface UpdateJobMatchProfileRequest {
    jobMatchProfile?: JobMatchProfile;
}

export interface UpdateJobMatchProfileOccupationsRequest {
    occupationUpdateRequest?: OccupationUpdateRequest;
}

/**
 * 
 */
export class JobMatchApi extends runtime.BaseAPI {

    /**
     */
    async addApplicationVersionRaw(requestParameters: AddApplicationVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationVersion>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/AddApplicationVersion`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationAddRequestToJSON(requestParameters.applicationAddRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationVersionFromJSON(jsonValue));
    }

    /**
     */
    async addApplicationVersion(requestParameters: AddApplicationVersionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationVersion> {
        const response = await this.addApplicationVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addJobMatchProfileOccupationsRaw(requestParameters: AddJobMatchProfileOccupationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/AddJobMatchProfileOccupations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OccupationUpdateRequestToJSON(requestParameters.occupationUpdateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async addJobMatchProfileOccupations(requestParameters: AddJobMatchProfileOccupationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.addJobMatchProfileOccupationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createApplicationRaw(requestParameters: CreateApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationGroup>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/CreateApplication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationCreateRequestToJSON(requestParameters.applicationCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationGroupFromJSON(jsonValue));
    }

    /**
     */
    async createApplication(requestParameters: CreateApplicationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationGroup> {
        const response = await this.createApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSavedAdvertRaw(requestParameters: CreateSavedAdvertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobResultItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/CreateSavedAdvert`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobResultItemFromJSON(jsonValue));
    }

    /**
     */
    async createSavedAdvert(requestParameters: CreateSavedAdvertRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobResultItem> {
        const response = await this.createSavedAdvertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteApplicationRaw(requestParameters: DeleteApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.applicationGroupId !== undefined) {
            queryParameters['applicationGroupId'] = requestParameters.applicationGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/DeleteApplication`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteApplication(requestParameters: DeleteApplicationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.deleteApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteSavedAdvertRaw(requestParameters: DeleteSavedAdvertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/DeleteSavedAdvert`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteSavedAdvert(requestParameters: DeleteSavedAdvertRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.deleteSavedAdvertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAdvertRaw(requestParameters: GetAdvertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobResultItem>> {
        const queryParameters: any = {};

        if (requestParameters.jobId !== undefined) {
            queryParameters['jobId'] = requestParameters.jobId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetAdvert`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobResultItemFromJSON(jsonValue));
    }

    /**
     */
    async getAdvert(requestParameters: GetAdvertRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobResultItem> {
        const response = await this.getAdvertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getApplicationRaw(requestParameters: GetApplicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationGroup>> {
        const queryParameters: any = {};

        if (requestParameters.applicationGroupId !== undefined) {
            queryParameters['applicationGroupId'] = requestParameters.applicationGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetApplication`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationGroupFromJSON(jsonValue));
    }

    /**
     */
    async getApplication(requestParameters: GetApplicationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationGroup> {
        const response = await this.getApplicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getApplicationTextRaw(requestParameters: GetApplicationTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.applicationGroupId !== undefined) {
            queryParameters['applicationGroupId'] = requestParameters.applicationGroupId;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['versionId'] = requestParameters.versionId;
        }

        if (requestParameters.returnAsWordDocument !== undefined) {
            queryParameters['returnAsWordDocument'] = requestParameters.returnAsWordDocument;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetApplicationText`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getApplicationText(requestParameters: GetApplicationTextRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getApplicationTextRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getApplicationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationGroup>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetApplications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationGroupFromJSON));
    }

    /**
     */
    async getApplications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationGroup>> {
        const response = await this.getApplicationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getJobMatchCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdvertCountResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetJobMatchCount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdvertCountResultFromJSON(jsonValue));
    }

    /**
     */
    async getJobMatchCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdvertCountResult> {
        const response = await this.getJobMatchCountRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getJobMatchProfileRaw(requestParameters: GetJobMatchProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobMatchProfile>> {
        const queryParameters: any = {};

        if (requestParameters.language !== undefined) {
            queryParameters['language'] = requestParameters.language;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetJobMatchProfile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobMatchProfileFromJSON(jsonValue));
    }

    /**
     */
    async getJobMatchProfile(requestParameters: GetJobMatchProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobMatchProfile> {
        const response = await this.getJobMatchProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMatchesForProfileRaw(requestParameters: GetMatchesForProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobMatchSearchResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetMatchesForProfile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobMatchSearchFiltersToJSON(requestParameters.jobMatchSearchFilters),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobMatchSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async getMatchesForProfile(requestParameters: GetMatchesForProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobMatchSearchResult> {
        const response = await this.getMatchesForProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOccupationsByStringRaw(requestParameters: GetOccupationsByStringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EscoOccupationSimple>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetOccupationsByString`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OccupationByTextRequestToJSON(requestParameters.occupationByTextRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EscoOccupationSimpleFromJSON));
    }

    /**
     */
    async getOccupationsByString(requestParameters: GetOccupationsByStringRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EscoOccupationSimple>> {
        const response = await this.getOccupationsByStringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSavedAdvertsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JobResultItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/GetSavedAdverts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JobResultItemFromJSON));
    }

    /**
     */
    async getSavedAdverts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JobResultItem>> {
        const response = await this.getSavedAdvertsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async jobDescriptionToOccupationsRaw(requestParameters: JobDescriptionToOccupationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OccupationSearchResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/JobDescriptionToOccupations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobDescriptionToOccupationsRequestToJSON(requestParameters.jobDescriptionToOccupationsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OccupationSearchResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async jobDescriptionToOccupations(requestParameters: JobDescriptionToOccupationsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OccupationSearchResultDto> {
        const response = await this.jobDescriptionToOccupationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeJobMatchProfileOccupationsRaw(requestParameters: RemoveJobMatchProfileOccupationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/RemoveJobMatchProfileOccupations`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: OccupationUpdateRequestToJSON(requestParameters.occupationUpdateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async removeJobMatchProfileOccupations(requestParameters: RemoveJobMatchProfileOccupationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.removeJobMatchProfileOccupationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setApplicationVersionRaw(requestParameters: SetApplicationVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationGroup>> {
        const queryParameters: any = {};

        if (requestParameters.applicationGroupId !== undefined) {
            queryParameters['applicationGroupId'] = requestParameters.applicationGroupId;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['versionId'] = requestParameters.versionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/SetApplicationVersion`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationGroupFromJSON(jsonValue));
    }

    /**
     */
    async setApplicationVersion(requestParameters: SetApplicationVersionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationGroup> {
        const response = await this.setApplicationVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unsubscibeEmailRaw(requestParameters: UnsubscibeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.candidateId !== undefined) {
            queryParameters['candidateId'] = requestParameters.candidateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/UnsubscibeEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async unsubscibeEmail(requestParameters: UnsubscibeEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.unsubscibeEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateJobMatchProfileRaw(requestParameters: UpdateJobMatchProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/UpdateJobMatchProfile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JobMatchProfileToJSON(requestParameters.jobMatchProfile),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateJobMatchProfile(requestParameters: UpdateJobMatchProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateJobMatchProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateJobMatchProfileOccupationsRaw(requestParameters: UpdateJobMatchProfileOccupationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/JobMatchApi/UpdateJobMatchProfileOccupations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OccupationUpdateRequestToJSON(requestParameters.occupationUpdateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateJobMatchProfileOccupations(requestParameters: UpdateJobMatchProfileOccupationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateJobMatchProfileOccupationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
